import React,{Component} from 'react'
import authService from '../services/authService'
export default class Navbar extends Component {

    handleLogout = () => {
        authService.logout();
        this.context.router.push('/login');
    };

    render() {
        return (
            <div>
                <nav className="navbar navbar-inverse navbar-fixed-top">
                    <div className="container">
                        <div className="navbar-header">
                            <span className="navbar-brand">Scala Times</span>
                        </div>
                        <ul className="nav navbar-nav navbar-right">
                            <li>
                                <a onClick={this.handleLogout} href="" hidden="true" id="loginLink" className={"navbar-link" + (authService.isLoggedOut() ? " hidden" : "")}>Logout</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        )
    }
}

Navbar.contextTypes = {
    router: React.PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/common/components/Navbar.js